import { render, staticRenderFns } from "./wheelOverlayText.vue?vue&type=template&id=136d4c25&scoped=true&"
import script from "./wheelOverlayText.vue?vue&type=script&lang=js&"
export * from "./wheelOverlayText.vue?vue&type=script&lang=js&"
import style0 from "./wheelOverlayText.vue?vue&type=style&index=0&id=136d4c25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d4c25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/path0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('136d4c25')) {
      api.createRecord('136d4c25', component.options)
    } else {
      api.reload('136d4c25', component.options)
    }
    module.hot.accept("./wheelOverlayText.vue?vue&type=template&id=136d4c25&scoped=true&", function () {
      api.rerender('136d4c25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/wheelOverlayText.vue"
export default component.exports